import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment/moment';

import DatePicker from '../../../../../../../../common/data-entry/DatePicker';
import Input from '../../../../../../../../common/data-entry/Input';
import { isTodayOrBefore } from '../../../../../../../../services/date/validators';
import { NS_COMMON, NSPP_PATIENT } from '../../../../../../../../services/i18n/namespaces';
import PhoneNumberInput from '../PatientContactDetails/PhoneNumberInput/PhoneNumberInput';

export default function GuardianDetails({
  handleInputChange,
  handlePhoneNumberChange,
  handleGuardianDobChange,
  getValidationMessage,
  info
}) {
  const { t } = useTranslation();
  const { guardianFirstName, guardianLastName, guardianPhone, guardianEmail, guardianDob } = info;
  return (
    <div className="row">
      <div className="col-12 apm-form-label">{t('addOrEdit.guardianDetails', { ns: NSPP_PATIENT })}</div>
      <div className="col-4">
        <Input
          label={t('addOrEdit.firstName', { ns: NSPP_PATIENT })}
          name="guardianFirstName"
          value={guardianFirstName}
          onChange={handleInputChange}
        />
      </div>
      <div className="col-4 mr-3">
        <Input
          label={t('addOrEdit.lastName', { ns: NSPP_PATIENT })}
          name="guardianLastName"
          value={guardianLastName}
          onChange={handleInputChange}
        />
      </div>
      <div className="col-4">
        <PhoneNumberInput
          label={t('phone', { ns: NS_COMMON })}
          name="guardianPhone"
          value={guardianPhone}
          onChange={handlePhoneNumberChange}
          validationMessage={getValidationMessage('guardianPhone')}
        />
      </div>
      <div className="col-4 mr-3">
        <Input
          label={t('email', { ns: NS_COMMON })}
          name="guardianEmail"
          value={guardianEmail}
          onChange={handleInputChange}
          validationMessage={getValidationMessage('guardianEmail')}
        />
      </div>
      <div className="col-4">
        <DatePicker.Manual
          label={t('dateOfBirth', { ns: NS_COMMON })}
          value={moment.isMoment(guardianDob) && guardianDob.format('DD/MMM/YYYY')}
          required={false}
          isValidDate={isTodayOrBefore}
          dateOnly={true}
          onChange={d => handleGuardianDobChange(d, 'dob')}
        />
      </div>
    </div>
  );
}
